import axios from 'axios';
import { BABYFACE_URL } from '../../../lib/routes/Routes';
import { ERROR_RETRY } from '../../../lib/Error';

export const getBabyfaceItemApi = `/item/conversion`;

export const getOptionGroup = async ({ id }) => {
  try {
    const response = await axios.get(
      BABYFACE_URL.concat(`/option-group/item/${id}`),
    );
    return response.data;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};

export const getDeadline = async () => {
  try {
    const response = await axios.get(
      BABYFACE_URL.concat(`/requests/expected-date`),
    );
    return response.data;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};

export const getBabyfaceItemId = async () => {
  try {
    const response = await axios.get(BABYFACE_URL.concat(getBabyfaceItemApi));
    return response.data.id;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};

export const getBabyfaceItemPrice = async () => {
  try {
    const response = await axios.get(BABYFACE_URL.concat(getBabyfaceItemApi));
    return response.data.price;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};
